import service from "../services/categories.service"; // Asegúrate de que el servicio esté configurado correctamente

export const categories = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
        async getCategories() { 
            try {
                const response = await service.getCategories();
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async save(context,data) {  
            try {
                const response = await service.createData(data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async delete(context, id) {
            try {
                const response = await service.deleteData(id);
                return response; // Puedes retornar la respuesta si es necesario
            } catch (error) {
                throw error.response; ; // Propaga el error para que sea manejado en el componente
            }
        },
    },
    mutations: {
    },
};
